import CoreuiController from "../lib/coreui-controller"
import ChipSet from "../coreui/chip-set"

export default class CoreuiChipSetController extends CoreuiController {
  static Component = ChipSet
}
